// extracted by mini-css-extract-plugin
module.exports = {"stats-section-container":"Stats_stats-section-container__comqf","stats-grid":"Stats_stats-grid__1NC3c"};